// 游戏评测
import request from '@/utils/request'

// 查询游戏评测图片地址
export function getEvaluat(query) {
  return request({
    url: '/business/game/product/evaluat/evaluateAddress',
    method: 'get',
    params: query
  })
}
